module.exports = __webpack_public_path__ + "static/media/post-germany.7f0d42ac.png";